import { mapGetters, mapActions } from 'vuex'

const mixin = {
  methods: {
    ...mapActions(['setResultSelected']),
    ...mapActions(['showOffResultDetails'])
  },
  computed: {
    ...mapGetters(['resultLoadingStatus']),
    ...mapGetters(['resultsSelected']),
    ...mapGetters(['results']),
    selectAll: {
      get: function () {
        if (this.results.length === 0) {
          return false
        }
        return this.results ? this.selected.length === this.results.length : false
      },
      set: function (value) {
        var selected = []
        if (value) {
          this.results.forEach(function (results) {
            selected.push(results.id)
          })
        }
        selected.length === 0 ? this.showOffResultDetails(false) : this.showOffResultDetails(true)
        this.selected = selected
      }
    },
    selected: {
      get: function () {
        return this.resultsSelected
      },
      set: function (value) {
        if (value) {
          this.setResultSelected(value)
        }
      }
    }
  },
  watch: {
    selected: function (newValue) {
      this.$emit('update:selected', newValue)
    }
  }
}

export default mixin
